var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_4252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8.3125C14 11.4543 10.8664 14 7.00002 14C5.98556 14 5.02306 13.825 4.15353 13.5105C3.82814 13.7484 3.29767 14.0738 2.66877 14.3473C2.01252 14.6316 1.22228 14.875 0.437517 14.875C0.259783 14.875 0.101189 14.7684 0.0328299 14.6043C-0.0355294 14.4402 0.00275179 14.2543 0.125799 14.1285L0.134002 14.1203C0.142205 14.1121 0.153142 14.1012 0.169549 14.082C0.199627 14.0492 0.246111 13.9973 0.303533 13.9262C0.415642 13.7895 0.566033 13.5871 0.719158 13.3355C0.992596 12.8816 1.25236 12.2855 1.30431 11.6156C0.484002 10.6859 1.74246e-05 9.5457 1.74246e-05 8.3125C1.74246e-05 5.1707 3.13361 2.625 7.00002 2.625C10.8664 2.625 14 5.1707 14 8.3125Z",
    fill: "#4B5563"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_4252"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.75H14V15.75H0V1.75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.1742aa1fb3571e989c1c9cb3f117dc06.svg";
export { ForwardRef as ReactComponent };